module.exports = __webpack_public_path__ + "img/bg-6.7aa3dfdc.jpg";